import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import ButtonComponent from '../../buttons/ButtonComponent/ButtonComponent';
import { buttonVariants } from '../../buttons/types';
import { generalEnums } from '../../../../utils/enums';

export default function TimeandExpenseCard({ type, styles, status, list, pending }) {
  const { t } = useTranslation();
  const accessTo = useSelector((state) => state.accessToParts);

  useEffect(() => {
    console.log('check spinner in QA - pending', pending);
    console.log('check spinner in QA - status', status);
  }, [pending, status]);

  const handleRender = () => {
    if (list?.ApprovedCount === 0 && list?.RejectedCount === 0) {
      return <h5>No updates for today</h5>;
    }
    return (
      <>
        {list?.ApprovedCount ? (
          <Link
            to={`/dashboard/${
              type === generalEnums.TIMESHEET ? 'timesheets' : 'expenses'
            }?page=1&start=&month=&year=&location=&status=Approved`}
          >
            <ButtonComponent variant={buttonVariants.ROUNDED_NOTIFY_POSITIVE} text={t('dashboard.cards.newApproved')}>
              <span className={styles.boldedFont}>{list?.ApprovedCount}</span>
            </ButtonComponent>
          </Link>
        ) : null}

        {list?.RejectedCount ? (
          <Link
            to={`/dashboard/${
              type === generalEnums.TIMESHEET ? 'timesheets' : 'expenses'
            }?page=1&start=&month=&year=&location=&status=Rejected`}
          >
            <ButtonComponent variant={buttonVariants.ROUNDED_NOTIFY_NEGATIVE} text={t('dashboard.cards.newRejected')}>
              <span className={styles.boldedFont}>{list?.RejectedCount}</span>
            </ButtonComponent>
          </Link>
        ) : null}
      </>
    );
  };

  const handleApproveRender = () => {
    if (list === 0) {
      return <span className={styles.noUpdates}>{t('dashboard.cards.noupdatestoday')}</span>;
    }
    return (
      <Link
        to={`/dashboard/${
          type === generalEnums.TIMESHEET
            ? 'timesheets?page=1&start=&month=&year=&location=&status=Pending'
            : 'expenses?page=1&day=&month=&year=&status=Pending&claim=&FirstName=&LastName='
        }`}
      >
        <ButtonComponent
          variant={buttonVariants.ROUNDED_NOTIFY_PENDING}
          text={type === generalEnums.TIMESHEET ? t('dashboard.cards.newtimesheets') : t('dashboard.cards.newexpenses')}
        >
          <span className={styles.boldedFont}>{list}</span>
        </ButtonComponent>
      </Link>
    );
  };

  if (status && !pending && accessTo.tAndEContractor) {
    return [handleRender()];
  }

  if (!pending && accessTo.tAndEApprover) {
    return [handleApproveRender()];
  }

  // eslint-disable-next-line react/jsx-key
  if (pending) return [<CircularProgress sx={{ color: '#0194d3' }} size={60} />];

  if (!status) {
    return [
      // eslint-disable-next-line react/jsx-key
      <h5 className={styles.validationMessage}>
        {type === generalEnums.TIMESHEET
          ? t('dashboard.cards.timesheetvalidate')
          : t('dashboard.cards.expensevalidate')}
      </h5>
    ];
  }
}
